module.exports = __webpack_public_path__ + "static/media/3en.27f7f1ff.jpg";